import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <Section className="pt-20 pb-12 text-center md:pt-32" data-id="element-1">
      <div className="inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-wide text-sage-dark bg-sage-light rounded-full" data-id="element-2">
        Menú + Lista + Swaps + Plan B — todo en un PDF
      </div>

      <h1 className="mb-6 text-4xl font-bold leading-tight md:text-5xl lg:text-6xl text-brown-heading" data-id="element-3">
        Tu semana de comida, resuelta.
      </h1>

      <p className="mb-12 text-xl md:text-2xl text-brown-body/80 font-serif italic" data-id="element-4">
        Menú + Lista de Compras Para Diabetes (sin ingredientes raros)
      </p>

      <div className="mb-12" data-id="element-5">
        <img src="https://cdn.magicpatterns.com/uploads/orjW8uLxAd1ihspgbSpf6A/heylloyd-image-1770447018053.png" alt="Mockup de Semana Resuelta — PDF de menú y lista de compras para diabetes mostrado en una tablet sobre una mesada de cocina" className="w-full max-w-lg mx-auto rounded-2xl shadow-xl" data-id="element-6" />
      </div>

      <div className="p-8 mb-12 text-left bg-white rounded-2xl shadow-sm border border-stone-100" data-id="element-7">
        <p className="mb-4 text-lg leading-relaxed" data-id="element-8">
          El peor momento no es cuando estás "comiendo mal".
        </p>
        <p className="mb-4 text-lg leading-relaxed" data-id="element-9">
          El peor momento es antes.
        </p>
        <p className="mb-4 text-lg leading-relaxed" data-id="element-10">
          Es ese segundo en el que abrís la heladera, estás cansada, y tu cabeza
          hace lo de siempre:
        </p>
        <p className="mb-6 text-xl font-medium text-amber italic" data-id="element-11">
          "¿Qué como hoy… sin mandarme una?"
        </p>
        <p className="mb-4 text-lg leading-relaxed" data-id="element-12">
          Y como no hay plan, terminás improvisando.
        </p>
        <p className="mb-4 text-lg leading-relaxed" data-id="element-13">
          Y la improvisación, con el tiempo, se vuelve una costumbre que te deja
          con la misma sensación:{' '}
          <span className="font-semibold text-brown-heading" data-id="element-14">
            cansancio + culpa + ruido mental.
          </span>
        </p>
        <p className="text-lg font-medium text-sage-dark" data-id="element-15">
          Este PDF existe para una sola cosa: sacarte decisiones de encima.
        </p>
      </div>

      <Button className="w-full md:w-auto text-xl font-bold shadow-xl shadow-sage/30" onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} data-id="element-16">
        Descargalo ahora — $9.990 ARS
        <ArrowRight className="ml-2 w-5 h-5" data-id="element-17" />
      </Button>
    </Section>;
}